import Customers from "@/models/loyaltyPanel/Customers";
import StoreCustomers from "@/models/loyaltyPanel/StoreCustomers";

export default {
    namespaced: true,

    state: () => ({
        tabDialog: false,
        mergeDialog: false,
        customers : [],
        storeCustomers : [],
        customersDetails : [],
        customerResponse: {
            response: false,
            status: 'success',
            message: '',
            error: false

        },
        formLoading: false,
        newCardIsValid: null,
        newCardLoading: false,
        customersTableLoading: false,
        customerData: new Customers(),
        exportedFile: null,
        customerTransactionsExportedFile: null,
        mergeDialogMobile: null,
        transDialogUserAccId: null,
        transDialogUserId: null,
        successCode: false,
        companyStores: [],
        userTransactions: [],
        companyStoresLoading: false,
        userTransItemsLength: 1,
        storesTotalPages: null,
        visibleColumns: localStorage.getItem("visibleColumns")&&JSON.parse(localStorage.getItem("visibleColumns"))||[
            {
                column: "user_account_id",
                isVisible: true
            },
            {
                column: "card_number",
                isVisible: true
            },
            {
                column: "mobile",
                isVisible: true
            },
            {
                column: "email",
                isVisible: true
            },
            {
                column: "first_name",
                isVisible: true
            },
            {
                column: "last_name",
                isVisible: true
            },
            {
                column: "total_transactions",
                isVisible: true
            },
            {
                column: "redeemed_points",
                isVisible: true
            },
            {
                column:"current_balance",
                isVisible: true
            },
            {
                column:"total_price",
                isVisible: true
            },
            // {
            //     column:"user_id",
            //     isVisible: false
            // },
            {
                column:"actions",
                isVisible: true
            },
        ],
        attributes: []
    }),
    getters: {
        formStores: state => state.formStores,
        countryCodes: state => state.countryCodes,
        customersDetails: state => state.customersDetails,
        customers: state => state.customers,
        storeCustomers: state => state.storeCustomers,
        customerResponse: state => state.customerResponse,
        newCardIsValid: state => state.newCardIsValid,
        newCardLoading: state => state.newCardLoading,
        customersTableLoading: state => state.customersTableLoading,
        formLoading: state => state.formLoading,
        mergeDialogMobile: state => state.mergeDialogMobile,
        transDialogUserAccId: state => state.transDialogUserAccId,
        transDialogUserId: state => state.transDialogUserId,
        userTransactions: state => state.userTransactions,
        userTransItemsLength: state => state.userTransItemsLength,
    },

    mutations: {
        setMode(state, payload) {
            state.mode = payload;
        },
        setCustomerDialog(state, payload) {
            state.customerDialog = payload;
        },
        setUserTransactions(state, payload) {
            state.userTransactions = payload;
        },
        setTabDialog(state, payload) {
            state.tabDialog = payload;
        },
        setUserTransItemsLength(state, payload) {
            state.userTransItemsLength = payload;
        },
        setCustomers: (state, payload) => {
            state.customers = payload;
        },
        setStoreCustomers: (state, payload) => {
            state.storeCustomers = payload;
        },
        setCustomerData: (state, payload) => {
            state.customerData = new Customers(payload);
        },
        setMergeDialogMobile: (state, payload) => {
            state.mergeDialogMobile = payload;
        },
        setTransDialogUserAccId: (state, payload) => {
            state.transDialogUserAccId = payload;
        },
        setTransDialogUserId: (state, payload) => {
            state.transDialogUserId = payload;
        },
        setCustomerDialogMode(state, payload) {
            state.customerDialogMode = payload;
        },
        setShowCustomerDialog(state, payload) {
            state.customerDialog = payload;
        },
        setFormStores(state, payload) {
            state.formStores = payload;
        },
        setCountryCodes(state, payload) {
            state.countryCodes = payload;
        },
        setCustomersDetails(state, payload){
            state.customersDetails = payload;
        },
        setFormLoading(state, payload){
            state.formLoading = payload;
        },
        setCustomerResponse(state, payload){
            state.customerResponse = payload;
        },
        setNewCardIsValid(state, payload){
            state.newCardIsValid = payload;
        },
        setNewCardLoading(state, payload){
            state.newCardLoading = payload;
        },
        setCustomersTableLoading(state, payload){
            state.customersTableLoading = payload;
        },
        setExportedFile(state, payload){
            state.exportedFile = payload
        },
        setCustomerTransactionsExportedFile(state, payload){
            state.customerTransactionsExportedFile = payload
        },
        setSuccessCode(state, payload) {
            state.successCode = payload;
        },
        setCompanyStores(state, payload) {
            state.companyStores = payload;
        },
        setCompanyStoresLoading(state, payload) {
            state.companyStoresLoading = payload;
        },
        setStoresTotalPages(state, payload) {
            state.storesTotalPages = payload;
        },
        setMergeDialog(state, payload) {
            state.mergeDialog = payload;
        },
        setVisibleColumns(state, payload) {
            state.visibleColumns = payload;
            localStorage.setItem("visibleColumns", JSON.stringify(payload));
        },
        setAttributes(state, payload) {
            state.attributes = payload;
        },
    },

    actions: {
        async loadCustomers({ commit }, body) {
            try {
                commit("setLoading", true, { root: true });
                let data
                let filter = ""
                Object.keys(body.filters).map((key) => {
                    if(body.filters[key]){
                        filter += "&" + key + "=" + body.filters[key]   
                    }
                })
                if(!body.itab){
                   
                    data =  await Customers.get(body.query,filter) 
                     
                    const  customers = data.data.data.data;
                    customers.map(item => {
                        item.points_balance = item.points_balance ? item.points_balance : "0"
                        item.redeemed_points = item.redeemed_points ? item.redeemed_points : "0"
                        item.total_amount = item.total_amount ? item.total_amount : "0"
                        item.total_transactions = item.total_transactions ? item.total_transactions : "0"
                    })
                    commit("setCustomers", customers);

                }else if(body.store_id){
                    data = await StoreCustomers.get(body.store_id, body.query, filter) 
                    let  storeCustomers = data.data.data.data;
                    // console.log(storeCustomers,'storeCustomers')
                    // storeCustomers = storeCustomers.reduce((a, c) => {
                    //     for (const [k, v] of Object.entries(c)) {
                    //         c[k] = v || '-'
                    //         c.mobile = parseInt(c.mobile) || null
                    //       }
                    //     if(!c.mobile){
                    //         return a
                    //     }
                    //     return [...a, c]
                    //  }, [])
                     commit("setStoreCustomers", storeCustomers);

                }
                
                // const { data } = await Customers.get(body.query,filter)
                const  pagination = data&&data.data&&data.data.data.pagination;
               if(pagination){
                commit("setServerItemsLength", pagination.total, {
                    root: true
                });
                
                commit("setServerPagination", pagination, {
                    root: true
                });
                commit("setServerPagination", pagination, {
                    root: true
                });
               }
                
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
            }
        },
        
        async loadStoreCustomers({ commit }, body) {
            try {
                commit("setLoading", true, { root: true });

                let filter = ""
                Object.keys(body.filters).map((key) => {
                    if(body.filters[key]){
                        filter += "&" + key + "=" + body.filters[key]   
                    }
                })
                
                const { data } =  await StoreCustomers.get(body.store_id, body.query, filter)
                let storeCustomers = data.data.data;
                const  pagination = data.data.pagination;

                storeCustomers.map(item => {
                    for (const [k, v] of Object.entries(item)) {
                        // v&&(item[k] = '-')
                        item[k] = v || '-'
                      }
                      return item
                })

                commit("setCustomers", storeCustomers);
                commit("setServerItemsLength", pagination.total, {
                    root: true
                });
                commit("setServerPagination", pagination, {
                    root: true
                });
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
            }
        },

        async getCustomerProfile({ commit }, body) {
            try {
                commit("setLoading", true, { root: true });
                
                const { data } = await Customers.getCustomerProfile(body.id);
                commit("setCustomerData", data.data)
                if(body.mode == 'update'){
                    commit("setDialog", true, { root: true });
                }
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
            }
        },

        async createNewCustomer({commit,state,dispatch}){
            try{
                commit("setLoading", true, { root: true });
                commit("setFormLoading", true);
                commit("setSuccessCode", false)
                let customerDetails = state.customerData
                delete customerDetails.card_numbers
                
                let res = await Customers.create(customerDetails);

                if(res.code == 200) {
                    commit("setSuccessCode", true)
                }

                commit("setCustomerData", new Customers())
                commit("setCustomerResponse", {
                    response: true,
                    status: res.data.status,
                    message: res.data.message.replace("_", " "),
                    error: false
                });
                commit("setErrorMessage",
                    "", { root: true }
                );
                dispatch("loadCustomers", {
                    query: "?page=1",
                    filters: {}
                })
                setTimeout( () => {
                    commit("setNewCardIsValid", null);
                    commit("setCustomerResponse", {
                            response: false,
                            status: 'success',
                            message: '',
                            error: false
                        }
                    );
                }, 3000 );
                commit("setDialog", false, { root: true });
                commit("setFormLoading", false);
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit("setFormLoading", false);
                commit("setErrorMessage", ex.response.data.message, {
                    root: true
                });
            }
        },

        async loadCardStatus({commit}, cardNumber){
            try{
                if(!cardNumber || "" + cardNumber.length < 4 ||  "" + cardNumber.length > 10){
                   return commit("setNewCardIsValid", null);
                }
                commit("setNewCardLoading", true);
                let res = await Customers.cardSearch({ card_number: cardNumber });
              
                if(res.data.status === "success" && res.data.data){
                    commit("setNewCardIsValid", true);
                }else{
                    commit("setNewCardIsValid", null);
                }
                commit("setNewCardLoading", false);
            
            } catch (ex) {
                if(ex.response.data.error && ex.response.data.error_type === "entity_error"){
                    commit("setNewCardIsValid", false);
                }else{
                    commit("setNewCardIsValid", null);
                }
                commit("setNewCardLoading", false);
              
            }

        },

        async loadCustomerDetails({commit, getters}, id){
            try{                
                commit("setLoading", true, { root: true });
                commit("setFormLoading", true);
                let res = await Customers.customerDetails(id);
            
                if(res.data.status === "success" && res.data.data){
                    commit("setCustomersDetails", [...(getters.customersDetails), res.data.data]);
                }
            
                commit("setLoading", false, { root: true });
                commit("setFormLoading", false);
            } catch (ex) {
                console.log(ex);
                commit("setLoading", false, { root: true });
                commit("setFormLoading", false);
               
            }

        },
        
        async loadUserTransactions({commit, getters}, q){
            try{                
                commit("setLoading", true, { root: true });
                commit("setFormLoading", true);
                let filter = q.query
                Object.keys(q.filters).map((key) => {
                    if(q.filters[key]){
                        filter += "&" + key + "=" + q.filters[key]   
                    }
                })
                let res = await Customers.getTransactions(getters.transDialogUserAccId, filter);
            
                if(res.data.status === "success" && res.data.data){
                    commit("setUserTransactions", res.data.data.transactions);
                    let  pagination = res.data.data.pagination;
                    if(pagination){
                        commit("setUserTransItemsLength", pagination.total);
                    }
                }
            
                commit("setLoading", false, { root: true });
                commit("setFormLoading", false);
            } catch (ex) {
                console.log(ex);
                commit("setLoading", false, { root: true });
                commit("setFormLoading", false);
               
            }

        },

        async updateCustomer({commit, state, getters, dispatch}){
            try{                
                commit("setLoading", true, { root: true });
                commit("setFormLoading", true);
                delete state.customerData.card_numbers
                delete state.customerData.card_number

                let res = await Customers.customerUpdate(state.customerData);
            
                if(res.data.status === "success" && res.data.data){

                    commit("setCustomersDetails", getters.customersDetails.filter(c => c.user_account_id === state.customerData.user_account_id ?  res.data.data : c));
                    commit("setCustomerResponse", {
                        response: true,
                        status: res.data.status,
                        message: res.data.message.replace("_", " "),
                        error: false
                    });
                    dispatch("loadCustomers", {
                        query: "?page=1",
                        filters: {}
                    })
                    setTimeout( () => {
                        commit("setCustomerResponse", {
                                response: false,
                                status: 'success',
                                message: '',
                                error: false
                            }
                        );
                    }, 3000 );
                }
                commit("setErrorMessage",
                    "", { root: true }
                );
                commit("setDialog", false, { root: true });
                commit("setLoading", false, { root: true });
                commit("setFormLoading", false);
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit("setFormLoading", false);
                commit("setErrorMessage", ex.response.data.message, {
                    root: true
                });
            }

        },

        async getExportedFileStatus({ commit, state }, type) {
            try {
                const { data } = await Customers.getExportedFileStatus(type)
                if(type == 'transactions'){
                    if(data.data){
                        commit("setCustomerTransactionsExportedFile",data.data)
                    }
                    
                }else{
                    commit("setExportedFile", data.data)
                }
            } catch (ex) {
                console.log(ex)
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response?.data.message
                    },

                    { root: true }
                );
            }
        },

        async exportFile({ state, commit }, params ) {
            try {
                commit("setLoading", true, { root: true });
                
                const { data } = await Customers.exportFile(params) 
                if(params?.user_id && data.data){
                    commit("setCustomerTransactionsExportedFile", data.data)
                    
                }else{
                    commit("setExportedFile", data.data)
                }

                commit("setLoading", false, { root: true });
            } catch (ex) {
                console.log(ex)
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response?.data.message
                    },

                    { root: true }
                );
            }
        },

        async mergeUsers({ commit, dispatch }, mobiles) {
            try {
                // ids.code = '2u95k74pjuqc6wpq';

                commit("setLoading", true, { root: true });
                
                let res = await Customers.mergeUsers(mobiles)
                commit("setLoading", false, { root: true });
                return res
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response?.data?.message || ex
                    },

                    { root: true }
                );
            }
        },

        async deleteExportedFile({ commit }, params) {
            try {
                commit("setLoading", true, { root: true });
                
                await Customers.deleteExportedFile(params)
                if(params.type == 'transactions'){
                    commit("setCustomerTransactionsExportedFile", null)
                    
                }else{
                    commit("setExportedFile", null)
                }
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response?.data?.message || ex
                    },

                    { root: true }
                );
            }
        },

        async loadStores({ commit, state }, body){
            try{
                commit("setCompanyStoresLoading", true);

                let { data } = await Customers.getStores(body.query); 
                if(body.page == 1){
                    commit("setCompanyStores", data.data.data);
                }else{
                    const stores = state.companyStores
                    data.data.data.map(item => {
                        stores.push(item)
                    })
                    commit("setCompanyStores", stores);
                }
                
                commit("setServerItemsPerPage", data.data.pagination.items_per_page, {
                    root: true
                });
                commit("setStoresTotalPages", data.data.pagination.total_pages)

                commit("setCompanyStoresLoading", false);
            } catch (ex) {
                commit("setCompanyStoresLoading", false);
            }
        },

        async addNewCardNumber({ commit, dispatch }, body){
            try{
                commit("setLoading", true, { root: true });
                
                await Customers.addNewCardNumber(body);

                dispatch("loadCustomers", {
                    query: "?page=1",
                    filters: {}
                })
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response?.data?.message || ex
                    },

                    { root: true }
                );
            }
        },

        async updateMobile({ commit, dispatch }, body){
            try{
                commit("setLoading", true, { root: true });
                
                let {data} = await Customers.updateMobile(body);

            
                commit("setLoading", false, { root: true });
                return data
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response?.data?.message || ex
                    },

                    { root: true }
                );
            }
        },

        async removePoints({ commit, dispatch }, id){
            try{
                commit("setLoading", true, { root: true });
                
                let {data} = await Customers.removePoints(id);
            
                commit("setLoading", false, { root: true });
                return data
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response?.data?.message || ex
                    },

                    { root: true }
                );
            }
        },

        async detachCard({ commit, dispatch }, payload){
            try{
                commit("setLoading", true, { root: true });
                
                let {data} = await Customers.detachCard(payload.user_account_id, {card_number: payload.card_number});
            
                commit("setLoading", false, { root: true });
                return data

            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response?.data?.message || ex
                    },

                    { root: true }
                );
            }
        }, 
        async importCustomers({ commit, dispatch }, file){
            try{
                commit("setLoading", true, { root: true });

                let payload = new FormData();
                payload.append("users", file);

                let {data} = await Customers.importCustomers(payload);
            
                commit("setLoading", false, { root: true });

                return data
                
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response?.data?.message || ex
                    },

                    { root: true }
                );
            }
        }, 

        async getAttributes({ commit, state }, query){
            try{
                commit("setLoading", true, { root: true });
                query = query || ''
                let { data } = await Customers.getAttributes(query); 
                    commit("setAttributes", data.data);

                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setCompanyStoresLoading", false);
            }
        },

        
        async createAttribute({ commit, state }, body){
            try{
                commit("setLoading", true, { root: true });
                // body.options= body.options || []
                let { data } = await Customers.createAttribute(body); 
                let success = data.status == 'success'
                if (success) {
                        commit("setAttributes", [...state.attributes, data.data ]);
                    }

                commit("setLoading", false, { root: true });
                return data

            } catch (ex) {
                commit("setCompanyStoresLoading", false);
            }
        },

        
        async updateAttribute({ commit, state }, body){
            try{
                commit("setLoading", true, { root: true });
                let id = body.user_account_attribute_definition_id
                body.user_account_attribute_definition_id = undefined
                body.user_account_attribute_definition_value_ids = undefined
                body.user_account_attribute_definition_values = undefined
                body.store_id = undefined
                body.type = undefined
                body.used = undefined
                let { data } = await Customers.updateAttribute(id, body); 
                let success = data.status == 'success'
                if (success) {
                        let attributeIndex = state.attributes.findIndex(x => x.user_account_attribute_definition_id != id);
                        state.attributes[attributeIndex] = data.data
                        // commit("setAttributes", state.attributes.filter(e => e.user_account_attribute_definition_id != id));
                    }

                commit("setLoading", false, { root: true });
                return data

            } catch (ex) {
                commit("setLoading", false, { root: true });
                console.log(ex)
                commit("setCompanyStoresLoading", false);
                return ex.response?.data
            }
        },
        
        async deleteAttribute({ commit, state }, id){
            try{
                commit("setLoading", true, { root: true });

                let { data } = await Customers.deleteAttribute(id); 
                let success = data.status == 'success'
                    if (success) {
                        commit("setAttributes", state.attributes.filter(e => e.user_account_attribute_definition_id != id));
                    }

                commit("setLoading", false, { root: true });

                return data

            } catch (ex) {
                commit("setCompanyStoresLoading", false);
            }
        },
        
        async deleteCustomer({ commit, state }, id){
            try{
                commit("setLoading", true, { root: true });

                let { data } = await Customers.deleteCustomer(id); 
                let success = data.status == 'success'
                    if (success) {
                        commit("setCustomers", state.customers.filter(e => e.user_account_id != id));
                    }

                commit("setLoading", false, { root: true });

                return data

            } catch (ex) {
                commit("setCompanyStoresLoading", false);
            }
        },
    }
};

